import { render, staticRenderFns } from "./addDiagnose.vue?vue&type=template&id=ad984d08&scoped=true&"
import script from "./addDiagnose.vue?vue&type=script&lang=js&"
export * from "./addDiagnose.vue?vue&type=script&lang=js&"
import style0 from "./addDiagnose.vue?vue&type=style&index=0&id=ad984d08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad984d08",
  null
  
)

export default component.exports